import api from '../requests';
import moment from 'moment';
import { filterString, toUpper, isEmptyArray } from '../../util/functions';
import { IDQS_TRADE_CATEGORY } from '../../util/tradeFilterConstants';
const FileDownload = require('js-file-download');
import queryString from 'query-string';

export function getTradeQueryString (params) {
  let queryParams = {
    symbol: toUpper(params.symbol),
    startDate: params.startDate,
    endDate: params.endDate,
    startTime: params.startTime,
    endTime: params.endTime,
    mpid: toUpper(params.mpid),
    side: filterString(params.side),
    orderCapacity: params.orderCapacity,
    clientOrderId: params.clientOrderId,
    execId: params.execId,
    liquidityIndicator: params.liquidityIndicator,
    category: filterString(params.category),
    minSize: params.minSize,
    maxSize: params.maxSize,
    sortDir: params.sortDir,
    sortOn: params.sortOn
  };
  return queryString.stringify(queryParams);
}

export async function getIdqsTrades (params, sort) {
  params.category = params.venue;
  if (isEmptyArray(params.category)) {
    params.category = IDQS_TRADE_CATEGORY;
  }
  let tradeQueryObject = { ...params, ...sort };
  let query = getTradeQueryString(tradeQueryObject);
  //  console.log(query);

  const response = await api.request({
    method: 'get',
    url: `/internal/idqs/trade-data?${query}`
  });
  return response.data;
}

export async function downloadIdqsTrades (params) {
  params.category = params.venue;
  if (isEmptyArray(params.category)) {
    params.category = IDQS_TRADE_CATEGORY;
  }
  let query = getTradeQueryString(params);

  const response = await api.request({
    method: 'get',
    responseType: 'blob',
    url: `/internal/idqs/trade-data/download?${query}`
  });

  FileDownload(response.data, `IDQS_Trades-${moment().format('MM/DD/YYYY')}.xlsx`);
}
